import ReportUtils from "../../../../../../utils/report-utils.js";
import {translate} from "../../../../../../components/translate/translate.jsx";

export const safeFormatDateTime = (value) => {
    if (!value) return "";

    if (typeof value === "string" && /^\d{2}\/\d{2}\/\d{4}( \d{2}:\d{2})?$/.test(value)) {
        return value;
    }

    try {
        return ReportUtils.formatDateTime(value) ?? "";
    } catch {
        return value ?? "";
    }
};

const safeTranslate = (value) => {
    if (value === null || value === undefined || value === "") return "";

    try {
        return translate(value) ?? value;
    } catch {
        return value;
    }
};

export const safeJsonJoin = (value) => {
    if (!value) return "";

    try {
        const parsed = JSON.parse(value);
        if (!Array.isArray(parsed)) return "";

        return parsed.filter(item => item !== null && item !== undefined && item !== "").join(", ");
    } catch {
        return "";
    }
};

export const safeJsonTranslateJoin = (value) => {
    if (!value) return "";

    try {
        const parsed = JSON.parse(value);
        if (!Array.isArray(parsed)) return "";

        return parsed.filter(item => item !== null && item !== undefined && item !== "").map(item => safeTranslate(item)).join(", ");
    } catch {
        return "";
    }
};